import React from "react";
import { useTable, useResizeColumns, useFlexLayout } from "react-table";
import { useSelector } from "react-redux";

const DashboardTable = () => {
    const dashboardData = useSelector((state) => state.NewDashboardNameHolds.NewDashboardRecords);

    const stateNames = React.useMemo(() => dashboardData.map(item => item.FilterName), [dashboardData]);
    // const stateNames = [...new Set(dashboardData.map(item => item.FilterName))];

    // const columns = React.useMemo(() => {
    //     return [
    //         { Header: "Status", accessor: "label", width: 200 },
    //         ...stateNames.map(state => ({
    //             Header: state,
    //             accessor: state,
    //             width: 120,
    //         })),
    //     ];
    // }, [JSON.stringify(stateNames)]);  // Avoids re-creating columns on every render

    // const columns = React.useMemo(() => {
    //     const stateColumns = dashboardData.map(({ FilterName }) => ({
    //         // Header: FilterName,
    //         Header: FilterName.length > 10 ? `${FilterName.substring(0, 7)}...` : FilterName, // Shorten long names

    //         accessor: FilterName
    //     }));
    //     return [
    //         { Header: "Status", accessor: "label" },
    //         ...stateColumns
    //     ];
    // }, [JSON.stringify(dashboardData)]);

    // const columns = React.useMemo(() => {
    //     const stateColumns = dashboardData.map(({ FilterName }) => ({
    //         Header: FilterName.length > 10 ? `${FilterName.substring(0, 7)}...` : FilterName,
    //         accessor: FilterName,
    //         width: 250, // Set a fixed width
    //     }));
    
    //     return [{ Header: "Status", accessor: "label", width: 250 }, ...stateColumns];
    // }, [JSON.stringify(dashboardData)]);
    


    // const columns = React.useMemo(() => {
    //     // Extract unique state names from all data rows
    //     const allStateNames = new Set();
    //     dashboardData.forEach(row => {
    //         Object.keys(row).forEach(key => {
    //             if (key !== "label") {
    //                 allStateNames.add(key);
    //             }
    //         });
    //     });

    //     const stateColumns = [...allStateNames].map(stateName => ({
    //         Header: stateName.length > 10 ? `${stateName.substring(0, 7)}...` : stateName,
    //         accessor: stateName
    //     }));

    //     return [
    //         { Header: "Status", accessor: "label" },
    //         ...stateColumns
    //     ];
    // }, [JSON.stringify(dashboardData)]);

    // const data = React.useMemo(() => {
    //     const labels = [
    //         { label: "KYC COM", key: "kyc_completed_count" },
    //         { label: "KYC PEN", key: "kyc_pending_count" },
    //         { label: "AWAIT RM APP", key: "awaiting_rm_approval_count" },
    //         { label: "REJECT OR DEC", key: "rejected_count" },
    //         { label: "AWAIT PAY APP", key: "awaiting_payroll_approval_count" },
    //     ];

    //     return labels.map(({ label, key }) => {
    //         const row = { label };
    //         dashboardData.forEach(state => {
    //             row[state.FilterName] = state[key] || 0;
    //         });
          
    //         return row;
    //     });
    // }, [JSON.stringify(dashboardData)]); // Prevents unnecessary recalculations
console.log(dashboardData ,"disaydasud dashboardData");

    const data = React.useMemo(() => {
        const labels = [
            { label: "KYC COMPLETED", key: "kyc_completed_count" },
            { label: "KYC Pending", key: "kyc_pending_count" },
            { label: "AWAITING RM APPROVAL", key: "awaiting_rm_approval_count" },
            { label: "Rejected or declined", key: "rejected_count" },
            { label: "Awaiting Payroll approval", key: "awaiting_payroll_approval_count" },
        ];

        return labels.map(({ label, key }) => {
            const row = { label };
            dashboardData.forEach(state => {
                row[state.FilterName] = state[key] || 0;
            });
            return row;
        });
    }, [JSON.stringify(dashboardData)]); // Prevents unnecessary recalculations

    // Define table columns
    const columns = React.useMemo(() => {
        const stateColumns = stateNames.map(name => ({
            Header: name.length > 10 ? `${name.substring(0, 7)}...` : name, // Shorten long headers
            accessor: name,
            // width: 'auto', // Set a reasonable width
        }));

        return [{ Header: "Status", accessor: "label" ,}, ...stateColumns];
    }, [JSON.stringify(stateNames)]);



    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable(
        { columns, data },
        useFlexLayout, // Enables column resizing
        useResizeColumns // Enables column resizing
    );


    return (
        // <div style={{ maxHeight: "300px", overflowY: "auto", overflowX: "auto", minWidth: "1000px", marginTop: "10px" }}>
        //     <table {...getTableProps()} 
        //     style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", tableLayout:"fixed" }}>
        //         <thead style={{ position: "sticky", top: 0, background: "#ddd" }}>
        //             {headerGroups.map(headerGroup => (
        //                 <tr {...headerGroup.getHeaderGroupProps()}>
        //                     {headerGroup.headers.map(column => (
        //                         <th {...column.getHeaderProps()} style={{ border: "1px solid #ccc", padding: "8px", position: "relative" }}>
        //                             {column.render("Header")}
        //                             <div {...column.getResizerProps()} style={{
        //                                 width: "5px",
        //                                 height: "100%",
        //                                 position: "absolute",
        //                                 right: 0,
        //                                 top: 0,
        //                                 cursor: "col-resize",
        //                                 background: "#ddd",
        //                             }} />
        //                         </th>
        //                     ))}
        //                 </tr>
        //             ))}
                

        //         </thead>
        //         <tbody {...getTableBodyProps()}>
        //             {rows.map(row => {
        //                 prepareRow(row);
        //                 return (
        //                     <tr {...row.getRowProps()} style={{ borderBottom: "1px solid #ccc" }}>
        //                         {row.cells.map(cell => (
        //                             <td {...cell.getCellProps()} style={{ border: "1px solid #ccc", padding: "8px", width: "250" }}>
        //                                 {cell.render("Cell")}
        //                             </td>
        //                         ))}
        //                     </tr>
        //                 );
        //             })}
        //         </tbody>

        //     </table>
        // </div>
// TicketingTableOverviewsDashboard
        <div style={{ maxHeight: "300px", overflowY: "auto", overflowX: "auto", minWidth: "1000px", marginTop: "10px" }}>
        <table className="" {...getTableProps()} 
            style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", tableLayout: "fixed" }}>
            <thead style={{ position: "sticky", top: 0, background: "#ddd" }}>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()} style={{ border: "1px solid #ccc", padding: "8px", position: "relative" }}>
                                {column.render("Header")}
                                <div {...column.getResizerProps()} style={{
                                    width: "5px",
                                    height: "100%",
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    cursor: "col-resize",
                                    background: "#ddd",
                                }} />
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                    prepareRow(row);
                    return (
                        <tr {...row.getRowProps()} style={{ borderBottom: "1px solid #ccc" }}>
                            {row.cells.map(cell => (
                                <td {...cell.getCellProps()} style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis"
                                }}>
                                    {cell.render("Cell")}
                                </td>
                            ))}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>


    );
};

export default DashboardTable;
